<div class="flex gap-1 mb-3 bg-slate-100 p-1">
  <button *ngFor="let tab of tabList ; index as i"
    class="flex-1 px-3 py-2 font-bold transition-all duration-100 focus:outline-none hover:scale-105 hover:bg-blue-950 hover:text-white"
    [ngClass]="i+1 === step_details?.step_mapping?.phase_sequence ? 'bg-blue-950 text-white rounded transform scale-105 hover:scale-105' : 'bg-blue-50 text-blue-800  border-2 border-blue-600'">
    {{ tab.name }}
  </button>
</div>
<app-trans-header-steper (currentStepChange)="currentStepChange($event)"></app-trans-header-steper>

<div class="mt-4">
  <div class="flex items-center justify-between mb-8 w-full">
    <div
      class="flex flex-nowrap items-center gap-1 bg-slate-200 p-1 rounded-xl border border-slate-300 shadow-sm overflow-x-auto">
      <ng-container *ngFor="let t of [
        { code: 'process', icon: 'pi-sitemap', txt: 'Process Flow', tip: 'View flow', action:'' },
        { code: 'comments', icon: 'pi-comments', txt: 'Comments', tip: 'View notes', action:'' },
        { code: 'report', icon: 'pi-file-pdf', txt: 'Reports', tip: 'Access reports', action:'getReportData' },
        { code: 'document', icon: 'pi-folder', txt: 'Documents', tip: 'Manage files', action:'getDocumentList' }
      ]">
        <button
          class="px-4 py-1 rounded-lg font-bold text-sm transition-all duration-300 flex items-center gap-2.5 whitespace-nowrap"
          [ngClass]="userGuide === t.code
            ? 'bg-slate-100 text-blue-700 shadow-md ring-1 ring-slate-300'
            : 'text-slate-700 hover:text-blue-700 hover:bg-slate-100/80'"
          (click)="userGuide = t.code; t.action && this[t.action]()" [pTooltip]="t.tip" tooltipPosition="top">

          <i class="pi text-base" [ngClass]="[t.icon, userGuide === t.code ? 'text-blue-700' : 'text-slate-500']"></i>
          <span>{{ t.txt }}</span>
        </button>
      </ng-container>
    </div>


  </div>

  <div class="mt-3">
    <div class="grid grid-cols-1">
      <div *ngIf="userGuide === 'process'">
        <div class="bg-white rounded-xs shadow " *ngIf="step_details">
          <ng-container [ngSwitch]="step_details?.code">
            <app-need-genration *ngSwitchCase="'R-ND'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'" [getUrl]="'/revenue/need-generation/?proposal_step='"
              [postUrl]="'/revenue/need-generation/'" (routeConfig)="showConfirm()">
            </app-need-genration>

            <app-need-genration *ngSwitchCase="'makeI_02'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [type]="'approval'" [schemeType]="'rev'"
              [getUrl]="'/revenue/approval/need-generation/?proposal_step='"
              [postUrl]="'/revenue/approval/need-generation/'" (routeConfig)="showConfirm()">
            </app-need-genration>

            <app-sotr *ngSwitchCase="'R-FSOTR'" [id]="step_details?.id" [proposalStep_id]="step_details?.proposal"
              [stepDetails]="step_details" [heading]="'Formulation of SOTRs'" [getUrl]="'/revenue/sotr-details/'"
              [postUrl]="'/revenue/sotr-details/'" (routeConfig)="showConfirm()">
            </app-sotr>

            <app-initiation-of-proposal *ngSwitchCase="'R-IP'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [getUrl]="'/revenue/initiation-of-proposal/?proposal_step='"
              [postUrl]="'/revenue/initiation-of-proposal/'" (routeConfig)="showConfirm()">
            </app-initiation-of-proposal>

            <app-aip *ngSwitchCase="'R-AIP'" [id]="step_details?.id" [step]="step_details" [stepDetails]="step_details"
              [getUrl]="'/revenue/aip-details/?proposal_step='" [postUrl]="'/revenue/aip-details/'"
              (routeConfig)="showConfirm()">
            </app-aip>

            <app-nomination-of-qa-agency *ngSwitchCase="'R-NOQA'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [getUrl]="'/revenue/nomination-qa/?proposal_step='"
              [postUrl]="'/revenue/nomination-qa/'">
            </app-nomination-of-qa-agency>

            <app-firm-response-submission *ngSwitchCase="'R-VI'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [format]="'upload'" [url]="'/revenue/dms-file/vendor/'" [schemeType]="'rev'"
              (routeConfig)="showConfirm()">
            </app-firm-response-submission>

            <app-eoi *ngSwitchCase="'R-EoI'" [id]="step_details?.id" [step]="step_details" [stepDetails]="step_details"
              [masterData]="masterData" [getUrl1]="'/revenue/eol-details/?proposal_step='"
              [postUrl1]="'/revenue/eol-details/'">
            </app-eoi>

            <app-upload-doc *ngSwitchCase="'R-UEOID'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'"></app-upload-doc>
            <app-shortlisting-vendors *ngSwitchCase="'R-SLV'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details"></app-shortlisting-vendors>
            <app-idex-rfp-soc *ngSwitchCase="'R-RFP-SOC'" [proposalName]="proposalName" [masterData]="masterData"
              [step]="step_details" [stepDetails]="step_details" [schemeType]="'revenue'"
              (routeConfig)="showConfirm()"></app-idex-rfp-soc>
            <app-aon *ngSwitchCase="'R-AoN'" [id]="step_details?.id" [step]="step_details" [stepDetails]="step_details"
              [schemeType]="'rev'" (routeConfig)="showConfirm()"></app-aon>
            <app-pre-rfp-meeting *ngSwitchCase="'RFP-V'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'" [getUrl]="'revenue/pre-rfp-meeting/'"
              [postUrl]="'revenue/pre-rfp-meeting/'" (routeConfig)="showConfirm()"></app-pre-rfp-meeting>
            <app-freeze-sotr *ngSwitchCase="'R-FS'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [getUrl]="'revenue/freeze-sotr/'"
              [postUrl]="'revenue/freeze-sotr/'"></app-freeze-sotr>
            <app-idex-commercial-rfp *ngSwitchCase="'I-RFP'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [proposalName]="proposalName" [schemeType]="'rev'"
              (routeConfig)="showConfirm()"></app-idex-commercial-rfp>
            <app-constitute-committee *ngSwitchCase="'R-MCommittee'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [title]="'Constitute TOC, TEC, TNC, PC'"
              [getUrl]="'revenue/constitute-committee/'" [postUrl]="'revenue/constitute-committee/'"
              (routeConfig)="showConfirm()" [schemeType]="'rev'"></app-constitute-committee>
            <app-pre-bid *ngSwitchCase="'R-PBC'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'" [getUrl]="'revenue/pre-bid/'"
              [postUrl]="'revenue/pre-bid/'" (routeConfig)="showConfirm()"></app-pre-bid>
            <app-revenue-bid *ngSwitchCase="'R-TO&RFP'" [stepDetails]="step_details" [proposalName]="proposalName"
              [url]="'/revenue/dms-file/vendor/'" (routeConfig)="showConfirm()" [schemeType]="'rev'"></app-revenue-bid>
            <app-revenue-bid *ngSwitchCase="'R-TEC'" [stepDetails]="step_details" [format]="'upload'"
              [url]="'/revenue/dms-file/vendor/'" (routeConfig)="showConfirm()" [schemeType]="'rev'"
              [proposalName]="proposalName"></app-revenue-bid>
            <app-revenue-poc *ngSwitchCase="'R-POC'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details"></app-revenue-poc>
            <app-technical-negotiations *ngSwitchCase="'R-TN'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'" [getUrl]="'revenue/technical-negotiations/'"
              [postUrl]="'revenue/technical-negotiations/'" (routeConfig)="showConfirm()"></app-technical-negotiations>

            <app-firm-capacity-assessment *ngSwitchCase="'F-CA'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'" [getUrl]="'revenue/firm-capacity-assessment/'"
              [postUrl]="'revenue/firm-capacity-assessment/'"
              (routeConfig)="showConfirm()"></app-firm-capacity-assessment>

            <app-banchmark *ngSwitchCase="'R-BM'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" (routeConfig)="showConfirm()" [schemeType]="'rev'"></app-banchmark>
            <app-commercial-evaluation *ngSwitchCase="'Q-CST'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'"
              (routeConfig)="showConfirm()"></app-commercial-evaluation>
            <app-commercial-negocatition *ngSwitchCase="'R-CN'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'"></app-commercial-negocatition>
            <app-final-offer *ngSwitchCase="'R-FO'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'" [getUrl]="'revenue/final-offer/'"
              [postUrl]="'revenue/final-offer/'" (routeConfig)="showConfirm()"></app-final-offer>
            <app-sanction-order *ngSwitchCase="'R-PSO'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'" [getUrl]="'revenue/sanction-order/'"
              [postUrl]="'revenue/sanction-order/'" (routeConfig)="showConfirm()"></app-sanction-order>
            <app-nominate-directorate *ngSwitchCase="'R-KM'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [getUrl]="'/revenue/nominate/steering/?proposal_step='"
              [postUrl]="'/revenue/nominate/steering/'" (routeConfig)="showConfirm()"
              [schemeType]="'rev'"></app-nominate-directorate>
            <app-constitute-committee *ngSwitchCase="'tdf_005'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [title]="'Constitute Committee'" [getUrl]="'revenue/constitute-committee/'"
              [postUrl]="'revenue/constitute-committee/'" (routeConfig)="showConfirm()"></app-constitute-committee>
            <app-upload-drawings *ngSwitchCase="'Rev_011'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" (routeConfig)="showConfirm()" [schemeType]="'rev'" ></app-upload-drawings>
            <app-upload-qap-atp *ngSwitchCase="'Rev_012'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-upload-qap-atp>
            <app-idex-prototype *ngSwitchCase="'tdf_018'" [proposalName]="proposalName" [proposalId]="proposalId"
              [step]="step_details" [stepDetails]="step_details" [schemeType]="'revenue'"
              (routeConfig)="showConfirm()"></app-idex-prototype>
            <app-upload-fats *ngSwitchCase="'Rev_017'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [getUrl]="'revenue/final-offer/'" [postUrl]="'revenue/final-offer/'"
              (routeConfig)="showConfirm()" [schemeType]="'rev'"></app-upload-fats>
            <app-idex-utrr *ngSwitchCase="'UET'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'rev'" (routeConfig)="showConfirm()"></app-idex-utrr>
            <app-user-certificate *ngSwitchCase="'Rev_014'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [getUrl]="'revenue/final-offer/'" [postUrl]="'revenue/final-offer/'"
              (routeConfig)="showConfirm()" [schemeType]="'rev'"></app-user-certificate>
            <app-bulk-production *ngSwitchCase="'R_029'" [stepDetails]="step_details" [schemeType]="'rev'"
              [proposalName]="proposalName"
              [urls]="{GPUrl:'/revenue/bulk/production/',TGPUrl:'/revenue/bulk-production/dates/'}"
              (routeConfig)="showConfirm()">
            </app-bulk-production>
            <app-project-closure *ngSwitchCase="'R_030'" [stepDetails]="step_details" [schemeType]="'rev'"
              [proposalName]="proposalName" [urls]="{GPUrl:'/revenue/project/closure/'}"
              (routeConfig)="showConfirm()"></app-project-closure>

            <app-sotr-rfp-complience-matrix *ngSwitchCase="'sotr_rfp_cm'" [stepDetails]="step_details"
              [proposalName]="proposalName" [url]="'/revenue/sotr-rfp-complience/'"
              (routeConfig)="showConfirm()"></app-sotr-rfp-complience-matrix>


            <app-upload-hat-sat *ngSwitchCase="'U-HAT'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [proposalName]="proposalName" [proposalId]="proposalId"
              [url]="'/revenue/hats/prototype/'" (routeConfig)="showConfirm()"></app-upload-hat-sat>
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="userGuide === 'report'"
      class="animate-fadeIn bg-slate-50 rounded-2xl p-4 shadow-sm border border-slate-300">
      <app-report *ngIf="apiResponse" [apiResponse]="apiResponse" [schemeType]="'revenue'"></app-report>
    </div>

    <div *ngIf="userGuide === 'document'" class="animate-fadeIn">
      <div class="border border-slate-300 rounded-2xl shadow-sm bg-slate-50 overflow-hidden">
        <div class="flex items-center justify-between bg-blue-900 border-b-2 border-blue-800 px-5 py-3 gap-4 shadow-lg">

          <div class="flex items-center gap-3 shrink-0">
            <div class="bg-blue-800 p-2 rounded-lg shadow">
              <i class="pi pi-folder-open text-white text-[18px]"></i>
            </div>
            <h2 class="text-lg font-extrabold text-white tracking-tight whitespace-nowrap drop-shadow-sm uppercase">
              Document Management
            </h2>
          </div>

          <div class="flex items-center gap-3 w-full max-w-lg justify-end">

            <div class="relative w-full max-w-[320px]">
              <i class="pi pi-search absolute left-3.5 top-1/2 -translate-y-1/2 text-blue-500 text-base"></i>
              <input type="text"
                class="pl-11 pr-2.5 py-2 w-full text-sm bg-white border-2 border-blue-500 rounded-lg focus:ring-2 focus:ring-blue-600/60 focus:border-blue-600 outline-none transition-all shadow"
                placeholder="🔍 Search files..." [(ngModel)]="searchText"
                (keyup.enter)="documentTable.filterGlobal(searchText, 'contains')" />
            </div>

            <button (click)="documentTable.clear()"
              class="flex items-center justify-center w-9 h-9 text-blue-700 bg-blue-100 hover:bg-blue-300 hover:text-blue-900 rounded-full transition-colors border border-blue-300 hover:border-blue-500 shadow"
              pTooltip="Clear Filters">
              <i class="pi pi-filter-slash text-base"></i>
            </button>
          </div>
        </div>

        <div class="p-4 border-b border-slate-200 bg-slate-100/70">
          <app-dmp [isEdit]="role_id === '18'" [proposalId]="proposalId"></app-dmp>
        </div>

        <div class="p-2">
          <ng-container *ngIf="documentList?.length; else noDocuments">
            <p-table #documentTable [value]="documentList" [rows]="10" [paginator]="documentList.length > 10"
              styleClass="p-datatable-sm" [globalFilterFields]="['name', 'type_document', 'description']">
              <ng-template pTemplate="header">
                <tr class="!bg-slate-100">
                  <th pSortableColumn="name" class="!py-4">File Name <p-sortIcon field="name"></p-sortIcon></th>
                  <th pSortableColumn="description">Description <p-sortIcon field="description"></p-sortIcon></th>
                  <th pSortableColumn="type_document">Category <p-sortIcon field="type_document"></p-sortIcon></th>
                  <th>Uploaded Date</th>
                  <th class="text-center">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr class="hover:bg-blue-100/60 transition-colors group">
                  <td>
                    <div class="flex items-center gap-2">
                      <i class="pi pi-file-pdf text-red-600 text-lg"></i>
                      <span class="font-semibold text-slate-800 truncate max-w-[200px]" [pTooltip]="item.name">{{
                        item.name }}</span>
                    </div>
                  </td>
                  <td><span class="text-slate-600 text-sm">{{ item.description || '--' }}</span></td>
                  <td>
                    <span
                      class="px-2 py-1 rounded-md bg-slate-200 text-slate-700 text-[10px] font-bold uppercase tracking-wider">
                      {{ item.type_document }}
                    </span>
                  </td>
                  <td class="text-xs text-slate-500">{{ item.uploaded_at | date: 'mediumDate' }}</td>
                  <td class="text-center">
                    <div class="flex gap-2 justify-center">
                      <a [href]="baseUrl + item.file" target="_blank"
                        class="p-2 text-blue-700 hover:bg-blue-200 rounded-lg transition-all" pTooltip="View"><i
                          class="pi pi-eye"></i></a>
                      <a [href]="baseUrl + item.file" [attr.download]="item.name"
                        class="p-2 text-emerald-700 hover:bg-emerald-200 rounded-lg transition-all"
                        pTooltip="Download"><i class="pi pi-download"></i></a>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="userGuide === 'comments'" class="animate-fadeIn">
      <div class="bg-slate-50 rounded-2xl shadow-sm border border-slate-300 p-6">
        <app-commenting-seet [id]="step_details.id" [stepDetails]="step_details"></app-commenting-seet>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->

<ng-template #noDocuments>
  <div class="flex flex-col items-center justify-center py-20 text-slate-400">
    <div class="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mb-4">
      <i class="pi pi-folder-open text-4xl text-slate-300"></i>
    </div>
    <h3 class="text-lg font-bold text-slate-600">No documents found</h3>
    <p class="text-sm">Documents associated with this proposal will appear here.</p>
  </div>
</ng-template>

<p-toast position="center" key="confirm" [baseZIndex]="9999">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-col w-full p-1">
      <div class="flex items-center gap-3 mb-4 bg-blue-50 p-3 rounded-xl border border-blue-100">
        <div class="w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center shadow-lg">
          <i class="pi pi-send"></i>
        </div>
        <div>
          <h4 class="text-sm font-black text-blue-900 uppercase tracking-tighter">Action Required</h4>
          <p class="text-[10px] text-blue-700 font-medium">Step: {{ step_details?.name }}</p>
        </div>
      </div>
      <textarea
        class="w-full min-h-[60px] rounded-md border border-slate-300 p-2 mb-3 text-xs font-medium text-slate-700 resize-y focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        placeholder="Add a comment or remarks for this action (optional)..." [(ngModel)]="comment"></textarea>

      <div class="flex flex-col gap-2">
        <button (click)="submitProposal(2)"
          class="w-full py-3 bg-blue-950 hover:bg-slate-900 text-white rounded-xl shadow-lg transition-all flex items-center justify-center gap-2 active:scale-95">
          <i class="pi pi-check-circle"></i>
          <span class="text-xs font-bold uppercase">Submit & Forward</span>
        </button>

        <div class="grid grid-cols-2 gap-2 mt-1">
          <button (click)="trigarFromChild()"
            class="py-2.5 bg-white border border-slate-200 hover:border-blue-300 text-slate-700 rounded-xl text-[10px] font-bold uppercase transition-all flex items-center justify-center gap-2">
            <i class="pi pi-cog"></i> Route Config
          </button>
          <button (click)="submitProposal(1)"
            class="py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-[10px] font-bold uppercase transition-all flex items-center justify-center gap-2">
            <i class="pi pi-save"></i> Save Draft
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<style>
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fadeIn {
    animation: fadeIn 0.4s ease-out forwards;
  }
</style>